import React from 'react';

import { AdminPage } from 'components';

import type { TemplateCustomizationViewModel } from '../../viewmodels/createTemplateCustomizationViewModel';
import { RecoveryBanner } from '../feedback/RecoveryBanner';
import { QuestionsPanel } from '../questions/QuestionsPanel';
import { SectionsRail } from '../rail/SectionsRail';
import { TemplateCustomizationBreadcrumbs } from './TemplateCustomizationBreadcrumbs';
import { TemplateHeader } from './TemplateHeader';

import styles from './TemplateCustomizationLayout.scss';

type Props = {
  viewModel: TemplateCustomizationViewModel;
  listPageUrl: string;
};

export function TemplateCustomizationLayout({ viewModel, listPageUrl }: Props) {
  return (
    <AdminPage className={styles.adminPage}>
      <div className={styles.page}>
        <div className={styles.frame}>
          <TemplateCustomizationBreadcrumbs
            viewModel={viewModel.breadcrumbs}
            listPageUrl={listPageUrl}
          />
          <TemplateHeader viewModel={viewModel.header} />
        </div>
        {viewModel.recoveryBanner && (
          <div className={styles.recovery}>
            <RecoveryBanner viewModel={viewModel.recoveryBanner} />
          </div>
        )}
        <div className={styles.columns}>
          <SectionsRail viewModel={viewModel.rail} />
          <QuestionsPanel viewModel={viewModel} />
        </div>
      </div>
    </AdminPage>
  );
}
